import {
  ByIdPayload,
  FailByIdPayload,
  NormalizedSingle,
  OperationReducerTypes,
  PayloadAction,
  SendByIdPayload,
  SuccessByIdPayload,
  uniqueActionType
} from '@industi/ngx-common';
import { CarbonPartCommissionPayload } from '../models/part-commission-payload';

export const CarbonPartCommissionAddActionTypes: OperationReducerTypes = {
  request: uniqueActionType('[carbon/part-commission] Add'),
  requestFail: uniqueActionType('[carbon/part-commission] Add fail'),
  requestSuccess: uniqueActionType('[carbon/part-commission] Add success'),
  requestClearErrors: uniqueActionType('[carbon/part-commission] Add clear errors'),
  requestClear: uniqueActionType('[carbon/part-commission] Add clear'),
};

export class CarbonPartCommissionAddAction implements PayloadAction {
  readonly type = CarbonPartCommissionAddActionTypes.request;

  constructor(public payload: SendByIdPayload<CarbonPartCommissionPayload>) {
  }
}

export class CarbonPartCommissionAddFailAction implements PayloadAction {
  readonly type = CarbonPartCommissionAddActionTypes.requestFail;

  constructor(public payload: FailByIdPayload) {
  }
}

export class CarbonPartCommissionAddSuccessAction implements PayloadAction {
  readonly type = CarbonPartCommissionAddActionTypes.requestSuccess;

  constructor(public payload: SuccessByIdPayload<NormalizedSingle>) {
  }
}

export class CarbonPartCommissionAddClearErrorsAction implements PayloadAction {
  readonly type = CarbonPartCommissionAddActionTypes.requestClearErrors;

  constructor(public payload: ByIdPayload) {
  }
}

export class CarbonPartCommissionAddClearAction implements PayloadAction {
  readonly type = CarbonPartCommissionAddActionTypes.requestClear;

  constructor(public payload: ByIdPayload) {
  }
}
